import { client } from '../config';
import { Language } from '../models/language';
import { isMeest } from '../utils/client/client.utils';

function getFlagEmoji(countryCode: string) {
  if (countryCode === 'GB') return '🇬🇧';
  if (countryCode === 'CA') return '🇨🇦';
  return '🇺🇸';
}

export const getLocalizations: (countryCode: string) => Language[] = (
  countryCode: string
) =>
  isMeest(client)
    ? [
        {
          code: 'en',
          languageLabel: 'English',
          flagEmoji: getFlagEmoji(countryCode),
        },
        { code: 'uk', languageLabel: 'Українська', flagEmoji: '🇺🇦' },
        { code: 'ru', languageLabel: 'Русский', flagEmoji: '🇷🇺' },
        { code: 'it', languageLabel: 'Italiano', flagEmoji: '🇮🇹' },
        { code: 'pl', languageLabel: 'Polski', flagEmoji: '🇵🇱' },
        { code: 'fr', languageLabel: 'Français', flagEmoji: '🇫🇷' },
        { code: 'es', languageLabel: 'Español', flagEmoji: '🇪🇸' },
        { code: 'de', languageLabel: 'Deutsch', flagEmoji: '🇩🇪' },
      ]
    : [
        { code: 'en', languageLabel: 'English', flagEmoji: '🇺🇸' },
        { code: 'pl', languageLabel: 'Polski', flagEmoji: '🇵🇱' },
      ];

export const getLocalizationsMap = (countryCode: string) =>
  getLocalizations(countryCode).reduce<{
    [key: string]: Language;
  }>((acc, curr) => {
    acc[curr.code] = curr;
    return acc;
  }, {});
